import { render, staticRenderFns } from "./AtendimentoPedido.vue?vue&type=template&id=109329a2&scoped=true&"
import script from "./AtendimentoPedido.vue?vue&type=script&lang=js&"
export * from "./AtendimentoPedido.vue?vue&type=script&lang=js&"
import style0 from "./AtendimentoPedido.vue?vue&type=style&index=0&id=109329a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109329a2",
  null
  
)

export default component.exports